import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import {Analytics} from "@vercel/analytics/react";
import Header from "./components/Header";
import {
    Home,
    Subscription,
    PaymentSuccess,
    PaymentFailed,
    Terms,
    Privacy,
    ForgetPassword,
    SuccessPassword,
    Contact
} from "./pages";

function App() {
    return (
        <div className="min-h-screen bg-[#0E101D] font-inter overflow-hidden">
            <Router>
                <Header/>
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/reset-password/:uid/:token/" element={<ForgetPassword/>}/>
                    <Route path="/success-password/" element={<SuccessPassword/>}/>
                    <Route path="/contact/" element={<Contact/>}/>
                    {/*<Route path="/subscription" element={<Subscription />} />*/}
                    {/*<Route path="/success" element={<PaymentSuccess/>}/>*/}
                    {/*<Route path="/failed" element={<PaymentFailed/>}/>*/}
                    <Route path="/terms" element={<Terms/>}/>
                    <Route path="/privacy" element={<Privacy/>}/>
                </Routes>
            </Router>
            <Analytics/>
        </div>
    );
}

export default App;
